import { useAtomValue } from 'jotai';
import { layoutAtom, sessionAtom } from '../state/atoms';
import { useInternalSidePanelSystem } from './useInternalSidePanelSystem';

/**
 * Reads the active panel's identity, subject, payload, and expanded-layout state.
 *
 * @typeParam TPayload - Expected payload shape; the hook does not validate it at runtime.
 * @returns The active session data and layout state, updated when their atoms change.
 * @throws An error when SidePanelSystemProvider is missing or no session is active.
 */
export function usePanelSession<TPayload = Record<string, unknown>>() {
    const { store } = useInternalSidePanelSystem();
    const session = useAtomValue(sessionAtom, { store });
    const layout = useAtomValue(layoutAtom, { store });

    if (!session) {
        throw new Error('usePanelSession must be used while a side-panel session is active.');
    }

    return {
        sessionId: session.sessionId,
        panelId: session.panelId,
        subject: session.subject,
        payload: session.payload as TPayload | undefined,
        isExpanded: layout.isExpanded
    };
}
